import NewsList from '../NewsList/NewsList';
import MetaSEO from '../MetaSEO/MetaSEO';
import {useEffect} from 'react';
import {getPostsList} from '../../data/articles';
import './NewsLanding.scss';

// Lists all posts on the news landing page, served statically from the bundled content snapshot.
const NewsLanding = () => {

    const resultsData = getPostsList();

    useEffect(() => {
        window.scrollTo(0,0);
    }, [])

    return (
        <>
            <MetaSEO
            title={`News, Updates, Tips, Education | PAW Patrol Academy | Preschool Learning App | iOS & Android`}
            canonical={`https://www.pawpatrolacademy.com/news`}
            description={`The latest updates, news, and tips from the Paw Patrol Academy App including best practices for preschool learning`}
            keywords="Preschool Learning and Education Articles, Tips, Learning App, Learning games, Education App, ABC, Coloring app, Alphabet, Spelling, Academy,Preschool app,Playtime,Fun,Adventure,Shapes,Music,Dance,Kindergarten app,Chase,Skye, Rubble, The Lookout,Paw patrol"
            type="webapp"
            name="Originator Kids | Spin Master"
            isFAQ={false}
            />
            <section className="news-landing">
                <h1 className="news-landing__title">News and Updates</h1>
                <NewsList resultsData={resultsData} />
            </section>
        </>
        
    )
}

export default NewsLanding;